"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQuery = parseQuery;
function parseQuery(query) {
  const q = query.startsWith("?") ? query.slice(1) : query;
  if (q.length === 0) return {};
  const params = new URLSearchParams(q);
  const out = {};
  for (const [key, raw] of params.entries()) {
    if (raw.trim() === "") continue;
    out[key] = raw === "true" ? true : raw;
  }
  return out;
}